// Material Kit 2 React pages
import MainPage from "pages/MainPage";

export default function MainPageFile() {
  return <MainPage />;
}
